export default "/learning-portal/resources";
